import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { useStoreon } from "storeon/react";

import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";

import { Title } from "comp/productselector/ProductsList";

import t from "translations";

const Wrap = styled.div(({ show }) => ({
  padding: show ? 10 : 0,
  background: "#f1f1f1",
  width: show ? 220 : 0,
  minWidth: show ? 220 : 0,
  display: "flex",
  maxHeight: "100%",
  overflowY: "auto",
  flexDirection: "column",
  alignItems: "stretch",
  position: "relative",
  "@media screen and (max-width: 480px)": {
    maxHeight: "none",
    minHeight: "100vh",
    minWidth: 0,
    width: show ? "100%" : 0,
  },
}));

const Item = styled(TreeItem)({
  ".MuiTreeItem-label:hover": {
    color: "#333",
  },
  ".MuiTreeItem-content": {
    marginBottom: 7,
  },
  "&.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label": {
    fontWeight: 800,
    backgroundColor: "transparent!important",
  },
});

const getChildCategories = (categories, parentId) =>
  categories.filter((c) => c.parentId === parentId);

export const Categories = ({ show, onCategoryChange, categoryId }) => {
  const [expanded, setExpanded] = React.useState([]);
 const { productCategories, products } = useStoreon(
    "productCategories",
    "products"
  );

  const categories =  productCategories.filter((c) => products.find((p) => p.categories.includes(c.id)))

  const handleToggle = (event, nodeIds) => {
    console.log(nodeIds);
    setExpanded(nodeIds);
  };

  const handleSelect = (event, nodeIds) => {
    console.log(nodeIds);
    onCategoryChange?.(nodeIds);
  };

  const parentCategories = categories
    .filter((c) => !c.parentId);

  return (
    <Wrap show={show}>
      <Title>{t.categories}</Title>
      <TreeView
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        expanded={expanded}
        selected={[categoryId]}
        onNodeToggle={handleToggle}
        onNodeSelect={handleSelect}
      >
        {parentCategories.map((cat) => {
          return (
            <Item
              nodeId={cat.id}
              label={cat.label}
              onLabelClick={(e) => {
                e.preventDefault();
                onCategoryChange?.(cat.id);
              }}
            >
              {getChildCategories(categories, cat.id).map((childCat) => {
                return (
                  <Item
                    nodeId={childCat.id}
                    label={childCat.label}
                    onLabelClick={() => onCategoryChange?.(childCat.id)}
                  />
                );
              })}
            </Item>
          );
        })}
      </TreeView>
    </Wrap>
  );
};
